import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, otpVerified, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!otpVerified) {
    const otpSetup = user?.otp_setup;
    const otpSetupRequired = otpSetup === 0 || otpSetup === "0" || otpSetup === false;
    if (otpSetupRequired) {
      return <Navigate to="/otp-setup" replace />;
    }
    return <Navigate to="/otp-verify" replace />;
  }

  return children;
};

export default ProtectedRoute;
